module.exports = __webpack_public_path__ + "static/live-fallback.cf8ebffe.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/live-fallback.jpg
// module id = 844
// module chunks = 0 1 2 3